/** Ideal Portfolio tab footer FAQs. */

export const LUMPSUM_IDEAL_PLANS_FAQS = [
  {
    title: 'What is Ideal Portfolio?',
    description:
      'Your Ideal Portfolio shows the funds you should hold and the recommended value in each fund. It gives you a view of what your portfolio should look like after following your current Allocation Plan.'
  },
  {
    title: 'How is my Ideal Portfolio different from my Allocation Plan?',
    description:
      'Your Ideal Portfolio shows the recommended destination, the funds and amounts you should hold. Your Allocation Plan shows the steps to get there, including which funds to sell, which funds to buy and how much to move.'
  },
  {
    title: 'Is my Ideal Portfolio personalised to me?',
    description:
      'Yes. It reflects your allocation strategy, based on your risk profile and investment preferences. Your existing holdings and any constraints on selling them also influence what appears in your Ideal Portfolio.'
  },
  {
    title: 'What does the ideal value shown against each fund mean?',
    description:
      'It is the recommended total value you should hold in that fund within the portfolio covered by your plan. It is not an additional amount to invest. Your Allocation Plan shows the transactions needed to move towards this value.'
  },
  {
    title: 'Do I need to invest additional money to reach my Ideal Portfolio?',
    description:
      'The ideal values show how the portfolio covered by your plan should be distributed across funds. They do not, by themselves, mean you need to add fresh money. Follow your Allocation Plan to understand how your existing investments should be reallocated.'
  },
  {
    title: 'Why is a fund marked ‘Sell later’ still in my Ideal Portfolio?',
    description:
      'We may be deferring a sell because it would attract short-term capital gains (STCG) tax, or because your ELSS investment is still locked in. The fund therefore remains in your current Ideal Portfolio. We’ll reassess it in your next plan and provide an updated recommendation based on the constraints applicable then.'
  },
  {
    title: 'Should I invest more in a fund marked ‘Sell later’?',
    description:
      'Its inclusion alone does not mean you should invest more in it. It may appear because your existing investment needs to be retained for now. Follow the buy recommendations in your Allocation Plan to know where to invest.'
  },
  {
    title: 'Does my portfolio need to match the ideal values exactly?',
    description:
      'The ideal values guide your recommended allocation. Actual fund values change with market movements, so they may not match these amounts at all times. Follow the transactions in your Allocation Plan to move towards your Ideal Portfolio.'
  },
  {
    title: 'Will my Ideal Portfolio change over time?',
    description:
      'Yes. It may change when your Allocation Plan is reviewed, as your portfolio, preferences, fund assessments or constraints on selling change. Refer to the Ideal Portfolio associated with your latest plan.'
  }
]
